/**
 * React Query hooks for tenants
 */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { tenantsApi } from '../api/tenants'
import type { TenantCreate, TenantUpdate } from '../types'

const TENANTS_KEY = ['tenants']

export function useTenants() {
  return useQuery({
    queryKey: TENANTS_KEY,
    queryFn: tenantsApi.list,
  })
}

export function useTenant(tenantId: string) {
  return useQuery({
    queryKey: [...TENANTS_KEY, tenantId],
    queryFn: () => tenantsApi.get(tenantId),
    enabled: !!tenantId,
  })
}

export function useCreateTenant() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: TenantCreate) => tenantsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TENANTS_KEY })
    },
  })
}

export function useUpdateTenant() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ tenantId, data }: { tenantId: string; data: TenantUpdate }) =>
      tenantsApi.update(tenantId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TENANTS_KEY })
    },
  })
}
